import { Box, Tooltip, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import * as apiVitals from '../../services/ApiVitals'
import { notifyError } from '../../components/NotifyToast'

import { IoArrowBackOutline } from "react-icons/io5";

import { Bar } from 'react-chartjs-2';

import { config } from '../../config.env';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    TimeScale,
    BarElement,
    Title,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    LinearScale,
    TimeScale,
    BarElement,
    Title,
    Legend,
    ChartDataLabels
);

export default function HealthHistory({ pageTitle, dataSource="IoTs" }) {

    const navigate = useNavigate()
    const location = useLocation()
    const pid = useSelector((state) => state.auth.user_data.pid); // Currently only used for Sonka HealthATM results

    const gender = new URLSearchParams(location.search).get('gender') === 'female' ? 1 : 0;

    return (
        <Box sx={{
            color: '#263238',
            display: 'flex',
            flexDirection: 'column',
            gridGap: 5,
            fontSize: 18,
            margin: { xl: '2rem', lg: '2rem', md: '2rem', sm: '2rem', xs: '2rem 1rem' },
            '@media (max-width: 1023px)': {
                gridGap: '3%',
                fontSize: 16,
            },
            '@media (max-width: 800px)': {
                gridGap: '1%',
                fontSize: 14,
            },
            '@media (orientation: portrait)': {
                fontSize: '6vw',
            }
        }}>

            <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                mb:2,
                '@media (orientation: portrait)': {
                    gridTemplateColumns: '1fr 9fr',
                    '@media (min-width: 1000px)': {
                        m: '1em',
                    },
                    mb: 0,
                }
            }}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    ml: '3rem',
                    '@media (orientation: portrait)': {
                        ml: 0,
                    }
                }}>
                    <Tooltip title="ย้อนกลับ">
                        <IconButton onClick={() => { navigate('/mainMenu') }} aria-label="Back" color="c_button" variant="resp">
                            <IoArrowBackOutline size='1.25em'/>
                        </IconButton>
                    </Tooltip>
                </Box>

                <Box sx={{
                    textAlign: 'center',
                    alignSelf: 'end',
                    color: 'c_title.main',
                    '@media (orientation: portrait)': {
                        alignSelf: 'center',
                    }
                }}
                >{pageTitle}</Box>

            </Box>

            <HistoryVitalSigns PID={pid} patientGender={gender} dataSource={dataSource} />

        </Box>
    )
}

const graphList = [
    "height",
    "weight",
    "bmi",
    "fat",
    "basal",
    "sys",
    "pulse",
    "temp",
    "spo2"
];

const HistoryVitalSigns = ({ PID, patientGender, dataSource }) => {

    //const location = useLocation()
    const [loading, setLoading] = useState(false)
    const [dataResult, setDataResult] = useState([])
    const [notData, setNotData] = useState('')

    // const [measureResult, setMeasureResult] = useState([])

    useEffect(() => {
        findResult()
    }, [])


    const findResult = async () => {

        setLoading(true);

        if ( dataSource === "IoTs" )
        {
            let res = await apiVitals.getIoTsResult()

            // MockUp
            if ((!res || !res['data']['status']) && !config.PRODUCTION)
            {
                console.log("Mockup VitalSigns");
                res = {
                    data: {
                        code: 200,
                        data: []
                    }
                };

                for (let i=0; i<6; i++)
                {
                    res.data.data.push({
                        "vstdate": `2025-${(1+Math.round(Math.random()*(1+i)*2)).toString().padStart(2,'0')}-${(1+Math.round(Math.random()*29)).toString().padStart(2,'0')}`,
                        "vsttime": "14:34:23.000",
                        'height': 150+Math.round(Math.random()*40),
                        'weight': 40+Math.round(Math.random()*80),
                        'bmi': 15+(Math.random()*30),
                        'fat': 5+(Math.random()*40),
                        'basal': 1000+Math.round(Math.random()*1000),
                        'sys': 90+Math.round(Math.random()*60),
                        'dia': 60+Math.round(Math.random()*40),
                        'pulse': 50+Math.round(Math.random()*70),
                        'temp': 35+(Math.random()*3),
                        'spo2': 90+Math.round(Math.random()*10),
                    });
                }
            }

            if (res)
            {
                if (res['data']['code'] === 200) {
                    
                    const resData = res['data']['data'];

                    for (let i=0; i<resData.length; i++)
                    {
                        const data = resData[i];
                        resData[i]['created_date'] = `${data.vstdate}T${data.vsttime}Z`;
                    }

                    setDataResult(resData.sort(function (a, b) {
                        return Date.parse(a.created_date) - Date.parse(b.created_date);
                    }))

                } else {
                    setNotData(res['data']['message'])
                }
            } else {
                notifyError('ไม่ตอบสนอง')
            }
        }
        else if ( dataSource === "HealthATM" )
        {
            //const res = await apiVitals.getHealthATMResult(PID);
            const res = await apiVitals.getHealthATMResultOmnix(PID);

            if (!res)
                notifyError('ไม่ตอบสนอง')
            else if (res.error)
            {
                setNotData(res.error)
                notifyError(res.error)
            }
            else if (res.status === 200)
            {                   
                //const resData = res['data'];
                const resData = res['data']['data'];
                const dataAll = [];

                for (let i=0; i<resData.length; i++)
                {
                    const rawData = resData[i].raw_data;
                    const data = typeof rawData === String ? JSON.parse(rawData.replaceAll("'",`"`)) : rawData;

                    const newData = {};
                    newData['created_date'] = resData[i]['measure_time'];
                    newData['height'] = data['Height']?.['Height'];
                    newData['weight'] = data['Height']?.['Weight'];
                    newData['bmi'] = data['Height']?.['BMI'];
                    newData['fat'] = data['Fat']?.['FatRate'];
                    newData['basal'] = data['Fat']?.['BasicMetabolism'];
                    newData['sys'] = data['BloodPressure']?.['HighPressure'];
                    newData['dia'] = data['BloodPressure']?.['LowPressure'];
                    newData['pulse'] = data['BloodPressure']?.['Pulse'];
                    newData['temp'] = data['Temperature']?.['Temperature'];
                    newData['spo2'] = data['Bo']?.['Oxygen'];

                    dataAll.push(newData);
                }
                
                dataAll.sort(function (a, b) {
                    return Date.parse(a.created_date) - Date.parse(b.created_date)
                })
                
                setDataResult(dataAll);
            }
            else notifyError('Error '+(res.status ? res.status : ''))
        }

        setLoading(false);
    }

    const fieldInfo = {
        height: {
            label:"Height",
            units:"cm",
            graphMax: 0,
            grader: (value) => { return 1; },
        },
        weight: {
            label:"Weight",
            units:"kg",
            graphMax: 0,
            grader: (value) => { return 1; },
        },
        bmi: {
            label:"BMI",
            units:"",
            graphMax: 55,
            grader: (value) => { return Math.max(0,Math.min(1-Math.abs(value-22)/8,1)); },
        },
        fat: {
            label:"Body Fat",
            units:"%",
            graphMax: 60,
            grader: (value) => {
                if ( patientGender === 0 )
                    return Math.max(0,Math.min(1-Math.abs(value-18)/12,1));
                else return Math.max(0,Math.min(1-Math.abs(value-30)/12,1));
            },
        },
        basal: {
            label:"Basal Metabolic Rate",
            units:"kcal",
            graphMax: 3000,
            grader: (value) => { return Math.min(value/1500,1); },
        },
        sys: {
            label:"Systolic",
            units:"mmHg",
            graphMax: 0,
            grader: (value) => { return Math.max(0,Math.min(1-Math.abs(value-105)/35,1)); },
        },
        dia: {
            label:"Diastolic",
            units:"mmHg",
            graphMax: 0,
            grader: (value) => { return Math.max(0,Math.min(1-Math.abs(value-70)/20,1)); }
        },
        pulse: {
            label:"Pulse",
            units:"bpm",
            graphMax: 135,
            grader: (value) => { return Math.max(0,Math.min(1-((value-60)/40),1)); }
        },
        temp: {
            label:"Temperature",
            units:"°C",
            graphMax: 45,
            grader: (value) => { return Math.max(0,Math.min(1-Math.abs(value-36.5)/3,1)); },
        },
        spo2: {
            label:"Oxygen Saturation",
            units:"%",
            graphMax: 100,
            grader: (value) => { return Math.min(Math.max(0,(value-80)/20),1); },
        }
    };

    const Chart = (props) => {

        const [barOptions, setBarOptions] = useState({});
        const [barData, setBarData] = useState({
            labels: [],
            datasets: []
        });

        const chartID = props.chartID;

        let chartDesc = fieldInfo[chartID].label;
        if (chartID !== "bmi")
        {
            if (chartID === "sys")
                chartDesc = "Blood Pressure: Systolic & Diastolic";

            chartDesc += " ("+fieldInfo[chartID].units+")";
        }

        const [active,setActive] = useState(false);

        useEffect(() =>
        {
            function prepGraphData(name)
            {
                const dataset = [];
                const listDates = [];
                const listValues = [];
                const listColors = [];

                let dataCount = dataResult.length;
                let count = 0;
                for (let i=dataCount-1; i>=0; i--)
                {
                    const data = dataResult[i];
                    if (!data[name])
                        continue;
                    
                    const value = parseInt(data[name]);
                    if (value <= 0)
                        continue;

                    const thisTime = Date.parse(data.created_date);
                    
                    const grade = fieldInfo[chartID].grader(value);
                    const col = "hsl("+Math.round(grade*120).toString()+",80%,50%,0.75)";

                    dataset.unshift({ 'date': thisTime, 'value': value, 'color': { stroke: col } });

                    count++;
                    if (count === 6)
                        break;
                };

                dataset.forEach((data) => {
                    listDates.push(new Date(data.date).toLocaleDateString('en-GB').replaceAll('/','-'));
                    listValues.push(data.value);
                    listColors.push(data.color.stroke);
                });

                setActive(dataset.length > 0);

                return {dates:listDates, data:listValues, colors:listColors};
            }

            let graphData = prepGraphData(chartID);
            barData.labels = graphData.dates;
            barData.datasets.push({label:chartID, data:graphData.data, backgroundColor:graphData.colors, grouped:false});

            if (chartID === "sys")
            {
                graphData = prepGraphData("dia");
                barData.datasets.push({
                    label:"dia",
                    data:graphData.data,
                    backgroundColor:graphData.colors.map((col) => {
                        return col.replace('50%,0.75','40%,1');
                    }),
                });
            }
            
            setBarData({
                labels:barData.labels,
                datasets:[...barData.datasets]
            });

            const w = window.innerWidth;
            const labelSize = 14 - (barData.labels.length/5);
            const xSize = labelSize - (512/w);//(window.innerWidth < 512 ? 2 : 1);
            const factor = w / window.innerHeight >= 1 ? 1 : w/432;

            setBarOptions({
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false },
                    datalabels: {
                        anchor: 'end',
                        font: { size: (labelSize*factor).toString() + '%' },
                        align: function(context) { return context.datasetIndex === 0 ? 'end' : 'start'; },
                        offset: function(context) { return context.datasetIndex === 0 ? -5 : 5; },
                        textStrokeWidth: function(context) { return context.datasetIndex === 0 ? 0 : 4; },
                        textStrokeColor: '#FFF',
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        suggestedMax: fieldInfo[chartID].graphMax,
                        border: { display: false },
                        ticks: { font: { size: (12*factor).toString() + '%' } },
                    },
                    x: {
                        border: { display: false },
                        grid: { display: false },
                        ticks: { font: {size: (xSize*factor).toString() + '%' } }
                    }
                },
                layout: {
                    padding: {
                        top: (13*factor)
                    }
                }
            });

        }, [dataResult]);

        return (
            active ?
                <Box sx={{
                    display: 'grid',
                    gridTemplateRows: '1fr 5fr',
                    backgroundColor: '#FFFFFF',
                    border: 2,
                    borderColor: '#E3E9F2',
                    borderRadius: '1em',
                    padding: '1em',
                    fontSize: '1em',
                }}>
                    <div align='center' justify='end'><b>{chartDesc}</b></div>
                    <Box sx={{
                        display: 'inline',
                        justifyContent: 'center',
                        alignItems: 'center',
                        '@media (orientation: portrait)': {
                            width:'80vw',
                            alignContent: 'center'
                        }
                    }}>
                        <Bar
                            options={barOptions}
                            data={barData}
                        />
                    </Box>
                </Box>
                :
                <></>
        );
    };

    return (
        <>
            <Loader loading={loading} />

            {notData === '' ?
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    alignContent: 'space-between',
                    gridGap: '1em',
                    mx:'1em',
                    color: '#082C91',
                    fontSize: '0.5em',
                    '@media (orientation: portrait)': {
                        flexDirection: 'column',
                        alignContent: 'center'
                    }
                }}>
                    { graphList.map((key) => (
                        <Chart key={key} chartID={key} />
                    ))}
                </Box>
                : 
                <div style={{ textAlign: 'center', margin: '20%', fontSize: 28 }}>ไม่พบข้อมูล</div>
            }
        </>
    )
}